import { render, staticRenderFns } from "./DateForm.vue?vue&type=template&id=3bdcdb46&"
import script from "./DateForm.vue?vue&type=script&lang=ts&"
export * from "./DateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports